import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Chip, Tooltip } from '@mui/material';
import { getCommunicationAttachmentBlob } from '../../api/communicationApi';

export default function ChatFileAttachment({ messageId, attachmentIndex, filename, label, icon, sx }) {
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);
  const controller = useRef(null);
  const objectUrl = useRef(null);
  const timer = useRef(null);
  const busy = useRef(false);
  useEffect(() => () => {
    controller.current?.abort();
    if (timer.current) clearTimeout(timer.current);
    if (objectUrl.current) URL.revokeObjectURL(objectUrl.current);
  }, []);
  const download = async () => {
    if (busy.current) return;
    busy.current = true;
    const requestController = new AbortController();
    controller.current = requestController;
    setLoading(true);
    setFailed(false);
    try {
      const blob = await getCommunicationAttachmentBlob(messageId, attachmentIndex, { signal: requestController.signal });
      if (requestController.signal.aborted) return;
      if (!blob.size) throw new Error('Empty attachment');
      if (objectUrl.current) URL.revokeObjectURL(objectUrl.current);
      if (timer.current) clearTimeout(timer.current);
      objectUrl.current = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl.current;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      timer.current = setTimeout(() => {
        URL.revokeObjectURL(objectUrl.current);
        objectUrl.current = null;
      }, 1000);
    } catch {
      if (!requestController.signal.aborted) setFailed(true);
    } finally {
      busy.current = false;
      if (!requestController.signal.aborted) setLoading(false);
    }
  };
  return (
    <Tooltip describeChild title={failed ? 'Datei konnte nicht geladen werden. Zum Wiederholen klicken.' : 'Datei speichern'}>
      <Chip clickable disabled={loading} onClick={download} icon={icon} label={loading ? 'Wird geladen…' : failed ? 'Erneut laden: ' + label : label} size="small" sx={sx} />
    </Tooltip>
  );
}
ChatFileAttachment.propTypes = {
  messageId: PropTypes.string.isRequired,
  attachmentIndex: PropTypes.number.isRequired,
  filename: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.node,
  sx: PropTypes.object,
};
